var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    { attrs: { title: "Work Samples", body: "Your work samples go here." } },
    [
      _c("FormImageUpload", { on: { update: _vm.loadFile } }),
      _vm.images.length
        ? _c(
            "div",
            { staticClass: "flex flex-wrap mt-6" },
            _vm._l(_vm.images, function (item, index) {
              return _c(
                "div",
                {
                  key: item.s3key,
                  staticClass: "mr-6 mb-2",
                  on: { click: () => _vm.showImg(index) },
                },
                [
                  _c("FormImageUploadPreview", {
                    attrs: { fileUrl: item.fileUrl, s3FileKey: item.s3key },
                    on: { remove: _vm.removeFile },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }